export default __webpack_public_path__ + "static/media/CheckmarkBadge.30a56cf6.png";